import React, { lazy } from "react";
import ReactDOM from "react-dom";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";

//import style files
import "bootstrap/dist/css/bootstrap.css";
import "./bundle/css/bootstrap.rtl.min.css";
import "./bundle/css/app.scss";
import "./bundle/css/responsive.css";
// import "./bundle/css/leaflet.css";

// import "./bundle/css";
import "./bundle/scss/index.scss";
// import 'react-modern-calendar-datepicker/lib/DatePicker.css';

import * as serviceWorker from "./registerServiceWorker";

// import AudioRecorder from 'audio-recorder-polyfill'

// import NoMatch from "./components/NoMatch";
// import RegisterAccount from "./components/Start/Register/RegisterAccount";
// import UserApp from "./components/user/UserApp";
// import ResetAccount from "./components/Start/ResetPassword/ResetAccount";
// import LoginNew from "./components/Start/LoginNew/LoginNew";
// import SpecialSecretaryLogin from "./components/Start/LoginNew/SpecialSecretaryLogin";
// import LinkAuthorization from "./components/Start/LoginNew/LinkAuthorization";

// const LoginNew = lazy(() => import("./components/Start/LoginNew/LoginNew"));
const LoginNew = lazy(() => import("./components/Start/LoginNew"));
const LinkAuthorization = lazy(() => import("./components/Start/LoginNew/LinkAuthorization"));
const SpecialSecretaryLogin = lazy(() => import("./components/Start/LoginNew/SpecialSecretaryLogin"));
const RegisterAccount = lazy(() => import("./components/Start/Register/RegisterAccount"));
const ResetAccount = lazy(() => import("./components/Start/ResetPassword/ResetAccount"));
const UserApp = lazy(() => import("./components/user/UserApp"));
const NoMatch = lazy(() => import("./components/NoMatch"));

// window.MediaRecorder = AudioRecorder

class App extends React.Component {
  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 1000));
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("preloader");
      if (ele) {
        // fade out
        ele.classList.add("hidden");
      }
    });
  }

  render() {
    return (
      <Router>
        <React.Suspense
          fallback={
            <div className='heart_loading_container'>
              <div className="icon-heart"><span className="dot"></span><span className="line"></span></div>
              <div style={{ margin: 16, color: '#7747c0', fontFamily: 'iranyekan' }}>در حال بارگذاری . . .</div>
            </div>
          }>
          <Switch>
            <Route exact={true} path="/" render={() => <Redirect to="/login" />} />
            <Route path="/login" component={LoginNew} />
            <Route path="/authorization" component={LinkAuthorization} />
            <Route path="/special-secretary" component={SpecialSecretaryLogin} />
            <Route path="/register" component={RegisterAccount} />
            <Route path="/password/reset" component={ResetAccount} />
            <Route path="/user/:key" component={UserApp} />
            <Route component={NoMatch} />
          </Switch>
        </React.Suspense>
      </Router>
    );
  }
}

ReactDOM.render(<App />, document.getElementById("app-mount"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
